<template>
  <CustomAddRemoveListPopup
    ref="modalRef"
    object-key="value"
    object-description="text"
    title="Selección de Evaluaciones"
    added-column-description="Evaluaciones Seleccionadas"
    removed-column-description="Evaluaciones Disponibles"
    add-all-description="Seleccionar Todas"
    remove-all-description="Remover Todas"
    :added-list="selectedEvaluations"
    :removed-list="avalaiblesEvaluations"
    :btn-classes="'hidden'"
    @updated="handleSave"
  />
</template>

<script>
import store from '@/store/index';
import CustomAddRemoveListPopup from '@/components/common/CustomAddRemoveListPopup';
import loading from '@/mixin/loading.mixin';

export default {
  name: 'SelectedEvaluationsModal',
  mixins: [loading],
  components: {
    CustomAddRemoveListPopup,
  },
  data() {
    return {
      apiUrl: '/api/studentEvaluation',
      studentSie: store.getters['$_student/StudentSie'],
      endDate: '',
      avalaiblesEvaluations: [],
      selectedEvaluations: [],
      evaluationsAddedList: '',
      evaluationsExcludedList: '',
      visible: false,
    };
  },
  methods: {
    async show() {
      this.$refs.modalRef.addedList = await this.getSelectedEvaluations();
      this.$refs.modalRef.removedList = await this.getAvailablesEvaluations();

      this.visible = true;
      this.$refs.modalRef.show();
    },
    handleSave(addedList, excludedList) {
      this.avalaiblesEvaluations = Array.from(excludedList);
      this.selectedEvaluations = Array.from(addedList);

      this.evaluationsAddedList = this.selectedEvaluations
        .map((x) => x.value)
        .join(', ');
      this.evaluationsExcludedList = this.avalaiblesEvaluations
        .map((x) => x.value)
        .join(', ');

      this.$emit(
        'selectedEvaluations',
        this.evaluationsAddedList,
        this.evaluationsExcludedList
      );
    },
    async getSelectedEvaluations() {
      return this.$ApiGet(
        `${this.apiUrl}/selectedevaluations?evaluationsIds=${this.evaluationsAddedList}`
      ).then((res) => (this.selectedEvaluations = res.data ? res.data : []));
    },
    async getAvailablesEvaluations() {
      return this.$ApiGet(`${this.apiUrl}/availablestudentsevaluations`, {
        studentSieId: this.studentSie,
        endDate: this.endDate,
        selectedEvaluations: this.evaluationsAddedList,
      }).then((res) => (this.avalaiblesEvaluations = res.data ? res.data : []));
    },
  },
  created() {
    this.getAvailablesEvaluations();
    this.getSelectedEvaluations();
  },
};
</script>
